export const priceReg = /^\d+(\.\d{1,2})?$/
export const negativePriceReg = /^-?\d+(\.\d{1,2})?$/
export const integerReg = /^\d+$/
export const integerWithNegativeReg = /^[-+]?\d+$/
export const zipCodeReg = /^(\d{5}|\d{5}-\d{4})$/
export const percentageReg = /^100$|^[1-9]?[0-9](\.[0-9]{1,4})?$/
export const managementFeeReg = /^100$|^0$|^[1-9]?[0-9](\.[0-9]{1,4})?$/
export const strongPass = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
